var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDevJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7df1e;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.42,
    y: 6.42,
    width: 37.15,
    height: 37.15,
    rx: 5.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.93,33.27a3.76,3.76,0,0,0,3.41,2.11c1.46,0,2.4-.73,2.4-1.74,0-1.17-.94-1.6-2.54-2.33L32.33,31c-2.54-1.09-4.21-2.39-4.21-5.22,0-2.62,2-4.65,5.08-4.65a5,5,0,0,1,4.93,2.83l-2.68,1.74a2.35,2.35,0,0,0-2.25-1.52,1.52,1.52,0,0,0-1.67,1.52c0,1,.65,1.45,2.18,2.11l.87.36c3,1.31,4.64,2.54,4.64,5.52s-2.46,4.86-5.8,4.86S28.05,37,27,34.94Zm-12.33.29c.58.95,1,1.82,2.25,1.82s1.88-.44,1.88-2.18V21.15h3.49v11.9c0,3.63-2.11,5.23-5.23,5.23a5.34,5.34,0,0,1-5.22-3.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevJs);
export default __webpack_public_path__ + "static/media/Icon-Dev-Js.6f3387e15622cb702e75f27c8fa28ad3.svg";
export { ForwardRef as ReactComponent };